import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from './handlers';
import { tokenCache } from '../utils/storage/localStorage';

declare const window: any;

export const brainTreeApi = createApi({
    reducerPath: 'brainTreeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_BRAINTREE ?? "https://npr-braintree.api.pens.com/v1/paypal",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['Braintree'],
    endpoints: (builder) => ({
        brainTreeCheckout: builder.mutation({
            query: (data) => ({
                url : 'checkout',
                method: 'POST',
                body: data
            }),
            async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
                try{
                    await queryFulfilled;
                }
                catch(error){
                    console.log(error);
                    dispatch(onErrorHandler({operation: 'braintree-checkout', err: JSON.stringify(error), errMsg: 'Error: while checkout', api: 'checkout'}));
                }
            },
        }),
        getPaypalAuthToken: builder.mutation({
            async queryFn({ cartId, paymentMethod }, {dispatch}, _extraOptions, baseQuery): Promise<any> {
                const paypalTokenCache = tokenCache('__paypal_token__');
                const cachedToken = paypalTokenCache.get(cartId);
                if (cachedToken) return { data: cachedToken };

                const response: any = await baseQuery({
                    url: '',
                    method: 'POST',
                    body: { cartId, paymentMethod }
                });
                const obj = {
                    token: response.data?.data?.CLIENT_AUTHORIZATION_TOKEN,
                    currency: response.data?.data?.CURRENCY
                };
                paypalTokenCache.set(obj, cartId);
                return { data: obj };
            },
            async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch(error) {
                    console.error(error);
                    dispatch(onErrorHandler({
                        operation: 'brainTreeApi.getPaypalAuthToken',
                        err: JSON.stringify(error),
                        errMsg: 'Error while getting paypal auth token.',
                        api: '/'
                    }));
                }
            },
        }),
        getCardAuthToken: builder.mutation({
            async queryFn({ cartId, paymentMethod }, {dispatch}, _extraOptions, baseQuery): Promise<any> {
                const cardTokenCache = tokenCache('__card_token__');
                const cachedToken = cardTokenCache.get(cartId);
                if (cachedToken) return { data: cachedToken };

                const response: any = await baseQuery({
                    url: '',
                    method: 'POST',
                    body: { cartId, paymentMethod }
                });
                const obj = {
                    token: response.data?.data?.CLIENT_AUTHORIZATION_TOKEN,
                    currency: response.data?.data?.CURRENCY
                };
                cardTokenCache.set(obj, cartId);
                return { data: obj };
            },
            async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch(error) {
                    console.error(error);
                    dispatch(onErrorHandler({
                        operation: 'brainTreeApi.getCardAuthToken',
                        err: JSON.stringify(error),
                        errMsg: 'Error while getting paypal auth token.',
                        api: '/'
                    }));
                }
            },
        }),
    }),
})


export const brainTreeApiV2Card = createApi({
    reducerPath: 'brainTreeApiV2Card',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_BRAINTREE_V2_CARD_CHECKOUT ?? "https://npr-braintree.api.pens.com/v2/card",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['Braintree'],
    endpoints: (builder) => ({
        brainTreeCheckout: builder.mutation({
            query: (data) => ({
                url : '/checkout',
                method: 'POST',
                body: data
            }),
            async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
                try{
                    await queryFulfilled;
                }
                catch(error){
                    console.log(error);
                    dispatch(onErrorHandler({operation: 'braintree-checkout', err: JSON.stringify(error), errMsg: 'Error: while checkout', api: 'checkout'}));
                }
            },
        }),
    }),
})

export const brainTreeApiV2ApplePay = createApi({
    reducerPath: 'brainTreeApiV2ApplePay',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_BRAINTREE_BASE_URL ?? "https://npr-braintree.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['Braintree'],
    endpoints: (builder) => ({
        brainTreeCheckout: builder.mutation({
            query: (data) => ({
                url : 'v2/applepay/checkout',
                method: 'POST',
                body: data
            }),
            async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
                try{
                    await queryFulfilled;
                }
                catch(error){
                    console.log(error);
                    dispatch(onErrorHandler({operation: 'braintree-checkout', err: JSON.stringify(error), errMsg: 'Error: while checkout', api: 'checkout'}));
                }
            },
        }),
    }),
})

export const {useBrainTreeCheckoutMutation} = brainTreeApi;